import { glossary, phrases } from '../data/translations'

const phraseMap = new Map<string, string>(
  Object.entries(phrases).map(([french, english]) => [normalize(french), english]),
)

function normalize(value: string): string {
  return value.replace(/\s+/g, ' ').trim().toLowerCase()
}

/** Applique la casse du mot source au mot traduit. */
function matchCase(source: string, target: string): string {
  if (source === source.toUpperCase() && source.length > 1) return target.toUpperCase()
  if (source[0] === source[0]?.toUpperCase()) return target.charAt(0).toUpperCase() + target.slice(1)
  return target
}

/**
 * Traduit un libellé du français vers l'anglais : correspondance exacte
 * d'abord, puis repli mot à mot pour le contenu rédigé.
 */
export function translateText(value: string): string {
  const trimmed = value.trim()
  if (!trimmed) return value

  const exact = phraseMap.get(normalize(trimmed))
  if (exact) return value.replace(trimmed, exact)

  const translated = trimmed.replace(/[A-Za-zÀ-ÿ’']+/g, (word) => {
    const entry = glossary[word.toLowerCase()]
    return entry ? matchCase(word, entry) : word
  })

  return translated === trimmed ? value : value.replace(trimmed, translated)
}
